import { HeadingH3 } from '@dreamstack/feature-components'
import { useTranslation } from '@dreamstack/i18n'
import type { FunctionComponent } from 'react'
import 'twin.macro'
import { RegionAverageTile } from '../../../components/RegionAverageTile'
import { CandleStickGraph } from '../CandleStickGraph'
import { AVG_RENT_PRICES } from './data/durchschnitlliche_mietpreise'
import { useDataForAverageTiles } from './libs/useDataForAverageTiles'
import { useDataForCandleStickGraph } from './libs/useDataForCandleStickGraph'

export interface RegionAvgRentPricesCandleStickProps {
  customProps: RegionAvgRentPricesCandleStickCustomProps
}

export type RegionAvgRentPricesCandleStickCustomProps = {
  region: string
}

export const RegionAvgRentPricesCandleStick: FunctionComponent<
  React.PropsWithChildren<RegionAvgRentPricesCandleStickProps>
> = ({ customProps }) => {
  const t = useTranslation()
  const tilesData = useDataForAverageTiles(customProps.region)

  const region = customProps.region
  const formatted_data = useDataForCandleStickGraph(
    region,
    AVG_RENT_PRICES,
    'miete'
  )

  const data = [
    {
      // TODO: add Translation
      id: t('accentro:districtLandingPageGraphs.candleStickGraph.rentPrice'),
      data: formatted_data,
    },
  ]

  if (region) {
    return (
      <div tw="flex flex-col gap-px-48">
        <CandleStickGraph
          data={data}
          title={`${t(
            'accentro:districtLandingPageGraphs.regionAverageGraph.averageRentPrices'
          )} in ${region}`}
          rangeStep={5}
        />
        <div tw="flex flex-row justify-start gap-px-16">
          <div tw="sm:w-min sm:whitespace-nowrap flex flex-col gap-px-12">
            <HeadingH3>
              {t(
                'accentro:districtLandingPageGraphs.regionAverageGraph.existingBuilding'
              )}
            </HeadingH3>
            <RegionAverageTile data={tilesData[1]} />
          </div>
          <div tw="sm:w-min sm:whitespace-nowrap flex flex-col gap-px-12">
            <HeadingH3>
              {t(
                'accentro:districtLandingPageGraphs.regionAverageGraph.newBuilds'
              )}
            </HeadingH3>
            <RegionAverageTile data={tilesData[5]} />
          </div>
        </div>
      </div>
    )
  } else
    return (
      <>
        {t(
          'accentro:districtLandingPageGraphs.regionPieChart.mustSelectRegion'
        )}
      </>
    )
}
